import SetupBackend from './config/config.js';

let config = {
  headers: {
    ApiKey: "c454de68f96741fae7584ee0023d0c6f56078ee01f534e4edb1412a6b7087aa5",
    System: "ApiGateway_ApiBackOffice"
  }
}

function authUser(data) {
  // return SetupBackend.post('/user', data)
  return true;
}
function getOrders(queries) {
  return SetupBackend.get(`/v1/ordem-cliente?Status=${queries.Status}&Inicio=${queries.Inicio}&Fim=${queries.Fim}&PageSize=${queries.PageSize}&Page=${queries.Page}&OrderBy=${queries.OrderBy}`, config)
}
function putOrders(data) {
  return SetupBackend.put('/v1/ordem-cliente/cancelamento', data, config)
}
function postOrders(data) {
  return SetupBackend.post('/v1/ordem-cliente/aprovacao', data, config)
}
function getHistory(queries) {
  return SetupBackend.get(`/v1/ordem-provedor/historico?Status=${queries.Status}&Inicio=${queries.Inicio}&Fim=${queries.Fim}&PageSize=${queries.PageSize}&Page=${queries.Page}&OrderBy=${queries.OrderBy}`, config)
}

// Taxas (BAAS)
function getBaasUsers() {
  return SetupBackend.get('/v1/user/indexbaas', config)
}

function updateBaasUser(data) {
  return SetupBackend.put(`/v1/user/editbaas`, data, config)
}

const BackendServices = {
    authUser,
    getOrders,
    putOrders,
    postOrders,
    getHistory,
    getBaasUsers,
    updateBaasUser
}

export default BackendServices;
